
import { supabase } from '@/integrations/supabase/client';

export const useEmailNotifications = () => {
  const sendNotification = async (
    type: 'order_status_update' | 'new_order' | 'driver_assignment',
    orderId: string,
    recipientEmail: string,
    recipientName?: string,
    orderDetails?: any
  ) => {
    try {
      const { data, error } = await supabase.functions.invoke('send-order-notifications', {
        body: {
          type,
          orderId,
          recipientEmail,
          recipientName,
          orderDetails
        }
      });

      if (error) {
        console.error('Error sending email notification:', error);
        return false;
      }

      console.log('Email notification sent successfully:', data);
      return true;
    } catch (error) {
      console.error('Error in sendNotification:', error);
      return false;
    }
  };

  return { sendNotification };
};
